import Modal from "~/common/components/Modal";
import { ACTIONS, type GSAPageState, useGSAFilterPopupLogic } from "~/GearboxSelectionAssistant/useGearboxSALogic";
import { useTranslation } from "react-i18next";
import { useCharacteristicFilterLogic } from "~/GearboxSelectionAssistant/components/CharacteristicsFilter/CharacteristicsFilter";
import { getDimensionFilterConfigs } from "~/GearboxSelectionAssistant/components/DimensionsFilter/DimensionsFilter";
import { Button } from "~/common/components/Button/Button";

import classes from "./GearboxSelectionAssistantFilterModal.module.less";
import classNames from "classnames";
import { useFetchGearboxSAData } from "~/GearboxSelectionAssistant/useFetchGearboxSAData";
import { Stacker } from "~/common/components/Stacker/Stacker";

interface Props {
  onClose: () => void;
  initialData: any;
  onSubmit: (data: GSAPageState) => void;
}

export const GearboxSelectionAssistantFilterModal = ({ onClose, initialData, onSubmit }: Props) => {
  const { t } = useTranslation();

  const [state, dispatch] = useGSAFilterPopupLogic(initialData);
  useFetchGearboxSAData(state, dispatch, true);

  const { allFilters, renderFilter } = useCharacteristicFilterLogic({
    onChange: (characteristic, value) => dispatch(ACTIONS.updateCharacteristic(characteristic, value)),
    definitions: state.characteristicDefinitions,
    values: state.characteristicValues,
    resultCount: state.resultCount,
  });

  const { configs: dimensionConfigs, renderFilter: renderDimensionFilter } = getDimensionFilterConfigs({
    onChange: (code, value) => dispatch(ACTIONS.updateDimension(code, value)),
    definitions: state.dimensionDefinitions,
    values: state.dimensionValues,
  });

  const submitCb = () => {
    onSubmit(state);
    onClose();
  };

  const resetCb = () => {
    dispatch(ACTIONS.resetAll());
  };

  const footer = (
    <Stacker gap={8} direction="row">
      <Button onClick={resetCb} variant={"text"}>
        {t("page.sa.gearbox.modal.btn.reset")}
      </Button>
      <Button onClick={submitCb}>
        {t("page.sa.gearbox.modal.btn.apply")}
      </Button>
    </Stacker>
  );

  return (
    <Modal
      onClose={onClose}
      modalClassName={classNames(classes.modal)}
      footerChildren={footer}
      title={t("page.sa.gearbox.characteristics.title")}
    >
      <div className={classes.filterList}>{allFilters.map(renderFilter)}</div>
      <h2 className={classes.sectionTitle}>{t("page.sa.gearbox.dimensions.title")}</h2>
      <div className={classes.filterList}>{dimensionConfigs.map(renderDimensionFilter)}</div>
    </Modal>
  );
};
